import React from 'react';
import { bbFindUserTagsByTagId} from "../../../util/bbHelpers";
import {useSelector} from "react-redux";

const BRLabsWrapper = (props)=>{
    const {children} = props;

    const {customers, customerInView, loadingTargets, loadingHumans} = useSelector(({customer}) => customer);
    const authUser = useSelector(({auth}) => auth.authUser);
    const customer = customers ? customerInView ? customers[customerInView] : null : null;

    // const isStaffAdmin = isCurrentUserMemberOf(authUser, "admin") || isCurrentUserMemberOf(authUser, "staff");

    const BRLabTagsUser = bbFindUserTagsByTagId(authUser, 56);
    const userHasLabsEnabled = BRLabTagsUser && BRLabTagsUser.length > 0;

    if(userHasLabsEnabled){
        return <>
            {children}
        </>

    } else{
        return null;

    }
}


export default BRLabsWrapper;